import React, { Fragment } from 'react'
import { AppFormTab } from 'api/index'
export interface IProps {
	tabList?: AppFormTab[]
	defaultTabId?: number
	onChange?: (index: number) => void
}
export default class AppFormTabs extends React.Component<IProps> {
	state = { defaultTabId: this.props.defaultTabId || 0 }

	renderItem = () => {
		let { tabList } = this.props
		let { defaultTabId } = this.state
		return tabList.map((tab: AppFormTab) => {
			let className = defaultTabId === tab.tabId ? 'app-form-tab app-form-tab-active' : 'app-form-tab'
			return (
				<li key={tab.tabId} className={className} onClick={() => this.onChange(tab.tabId)}>
					{tab.title}
				</li>
			)
		})
	}

	onChange = (defaultTabId: number) => {
		if (defaultTabId === this.state.defaultTabId) return
		this.props && this.props.onChange && this.props.onChange(defaultTabId)
		this.setState({ defaultTabId })
	}

	render() {
		return (
			<Fragment>
				<div className="app-form-tabs">
					<ul className="app-form-tabs-list">{this.renderItem()}</ul>
				</div>
			</Fragment>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/AppFormLayout/AppFormTabs.tsx